NotifyDirective.$inject = ['notify'];
function NotifyDirective(notify) {
    return {
        scope: true,
        template: require('./views/notify.html'),
        link: function (scope, element, items) {
            scope.messages = notify.messages;
            scope.close = function (message) {
                notify.pop(message.id);
            };
        }
    };
}
angular.module('rinca.core.directives.notify', [])
    .directive('notify', NotifyDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/NotifyDirective.ts
// module id = 300
// module chunks = 0